import { render, staticRenderFns } from "./currentextract.vue?vue&type=template&id=23642e30&"
import script from "./currentextract.vue?vue&type=script&lang=js&"
export * from "./currentextract.vue?vue&type=script&lang=js&"
import style0 from "./currentextract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports